<template>
  <div id="app" class="main-content">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Public+Sans&display=swap');

body {
  font-family: 'Public Sans', sans-serif;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #FFFFFF;



}

.main-content {
  :/*background-color: #F5F7F9;*/
  background-color: #f7f9fb;
  font-family: 'Public Sans', sans-serif;
  font-size: 20px;
  /*background: url("@/assets/section2/bg-img.jpg");*/
}

nav {
  padding: 30px;
}

nav a {
  font-weight: bold;
  color: #2c3e50;
}

nav a.router-link-exact-active {
  color: #42b983;
}
</style>
